<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { useMapGetter } from 'dashboard/composables/store';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const emit = defineEmits(['agentsFilterSelection']);

const store = useStore();
const selectedOptions = ref([]);
const isDisabled = ref(false); // 控制是否禁用选择

// 获取 Vuex 数据
const options = computed(() => store.getters['agents/getAgents']);
const currentUser = useMapGetter('getCurrentUser');

// 权限检查
const { checkPermissions } = usePolicy();
const filteredOptions = computed(() => {
  if (!checkPermissions(['encrypt_message'])) {
    return options.value;
  }
  return options.value.filter(option => option.id === currentUser.value.id);
});

// 监听 filteredOptions 的变化
watch(
  filteredOptions,
  newOptions => {
    // 如果筛选后仅剩下当前用户，则自动选中并禁用选择
    if (newOptions.length === 1 && newOptions[0].id === currentUser.value.id) {
      selectedOptions.value = [newOptions[0]];
      isDisabled.value = true; // 禁用选择
    } else {
      isDisabled.value = false; // 启用选择
    }
  },
  { immediate: true } // 确保在组件挂载时立即执行一次
);

// 生命周期钩子：加载 agents 数据
onMounted(() => {
  store.dispatch('agents/get');
});

// 处理选择事件
const handleInput = () => {
  emit('agentsFilterSelection', selectedOptions.value);
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOptions"
      class="no-margin"
      :options="filteredOptions"
      track-by="id"
      label="name"
      multiple
      :close-on-select="false"
      :clear-on-select="false"
      hide-selected
      :placeholder="t('CSAT_REPORTS.FILTERS.AGENTS.PLACEHOLDER')"
      selected-label
      :select-label="t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      :deselect-label="t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
      @update:model-value="handleInput"
      :disabled="isDisabled"
    />
  </div>
</template>
